var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cassie-vertical-md"},[_c('BasicForm',{attrs:{"item":_vm.item,"name-key":_vm.nameKey},on:{"update:item":_vm.updateItem}}),_c('Dropdown',{attrs:{"value":_vm.item.organisationTypeId,"items":_vm.organisationTypes.map(function (ref) {
	var organisationTypeId = ref.organisationTypeId;
	var organisationTypeName = ref.organisationTypeName;

	return ({ value: organisationTypeId, text: organisationTypeName });
}),"label":"Type *"},on:{"input":function($event){return _vm.updateItemProperty('organisationTypeId', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }